import { environment } from '@lla-platform/core/core-util'

export const PAYMENTS_API_URL = {
  paymentsList: `${environment.apiUrl}/payments/filters`,
  exportPaymentsList: `${environment.apiUrl}/payments/filters/export`
}
